export const menuData = [
    {
      name: "RETAIL AREA",
      path: "B10_1_20",
          child: [
            {
              name: "Kinetic Artwork",
              path: "B10_1_20",
            },
            {
              name: "Canopy Shade Tree",
              path: "B10_1_19",
            },
          ]
    },
    {
      name: "Orchard Hill I",
      path: "/",
      child: [
        {
          name: "Level 1",
          path: "/",
          child: [
                  {
              name: "Residential Entrance",
              path: "B10_1_1",
            },
            {
              name: "Emerald Residential Lounge",
              path: "B10_1_13",
            },
            {
              name: "Canvas Game Room",
              path: "B10_1_12",
            },
            {
              name: "Apex Co-working Space",
              path: "B10_1_7",
            },
            {
              name: "Nexus Kids’ Playroom",
              path: "B10_1_14",
            },
            {
              name: "Jaden Meeting Room",
              path: "B10_1_9",
            },
            {
              name: "Riverstone Grand Lobby",
              path: "B10_1_5",
            },
          ],
        },
        {
          name: "Level 5",
          path: "/",
          child: [
            {
              name: "Crystal 50m Lap Pool",
              path: "B10_5_4",
            },
            {
              name: "JACUZZI",
              path: "B10_5_11",
            },
            {
              name: "Pool Cabana",
              path: "B10_5_5",
            },
            {
              name: "Shallow Pool",
              path: "B10_5_10",
            },
            {
              name: "Kids' Pool",
              path: "B10_5_12",
            },
            {
              name: "Dance Studio",
              path: "B10_5_14",
            },
            {
              name: "Geo-Gym",
              path: "B10_5_15",
            },
            {
              name: "BBQ by the pool",
              path: "B10_5_3",
            },
            {
              name: "Flower Garden",
              path: "B10_5_7",
            },
            {
              name: "Coral Dining Room",
              path: "B10_5_2",
            },
            {
              name: "Leisure Spa Pool",
              path: "B10_5_13",
            },
            {
              name: "",
              path: "/",
            },
          ],
        },
        {
          name: "Level 13",
          path: "/",
          child: [
            {
              name: "Group Sitting Lounge",
              path: "B10_13_4",
            },
            // {
            //   name: "Reading Nook",
            //   path: "B10_13_5",
            // },
            {
              name: "Swing Bed",
              path: "B10_13_5",
            },
            {
              name: "Social Court",
              path: "B10_13_3",
            },
            // {
            //   name: "Play Table",
            //   path: "B10_13_13",
            // },
            {
              name: "Billiard Table",
              path: "B10_13_12",
            },
            {
              name: "Kids' Playground",
              path: "B10_13_8",
            },
            {
              name: "Cosmic Library",
              path: "B10_13_2",
            },
            {
              name: "Ruby Sports Hub",
              path: "B10_13_10",
            },
          ],
        },
        {
          name: "Level 24",
          path: "/",
          child: [
            {
              name: "Prisma Sky Lounge",
              path: "B10_24_3",
            },
          ],
        },
      ],
    },
    {
      name: "Orchard Hill II",
      path: "/about",
      child: [
        {
          name: "Level 1",
          path: "/",
          child: [
                   {
              name: "Residential Entrance",
              path: "B9_1_1",
            },
            {
              name: "Claystone Game Room",
              path: "B9_1_11",
              child: [],
            },
            {
              name: "Gemstone Co-working Space",
              path: "B9_1_8",
              child: [],
            },
            {
              name: "Silver Glaze Grand Lobby",
              path: "B9_1_6",
              child: [],
            },
            {
              name: "Pearl Residential Lounge",
              path: "B9_1_5",
              child: [],
            },
            {
              name: "Vivid Kids’ Playroom",
              path: "B9_1_14",
              child: [],
            },
            {
              name: "Topaz Meeting Room",
              path: "B9_1_12",
              child: [],
            },
          ],
        },
        {
          name: "Level 4",
          path: "/",
          child: [
            {
              name: "Yoga Studio",
              path: "B9_4_1",
              child: [],
            },
            {
              name: "Vertex Gym (lower level)",
              path: "B9_4_2",
              child: [],
            },
          ],
        },
        {
          name: "Level 5",
          path: "/",
          child: [
            {
              name: "Azu 50m Lap Pool",
              path: "B9_5_9",
              child: [],
            },
            {
              name: "Jacuzzi",
              path: "B9_5_2",
              child: [],
            },
            {
              name: "Shallow Pool",
              path: "B9_5_7",
              child: [],
            },

            {
              name: "Kids' Pool",
              path: "B9_5_5",
              child: [],
            },
            {
              name: "Pool Cabana",
              path: "B9_5_4",
              child: [],
            },
            {
              name: "BBQ by the pool",
              path: "B9_5_8",
              child: [],
            },
            {
              name: "Vertex Gym (upper level)",
              path: "B9_5_14",
              child: [],
            },
            {
              name: "Lace Gourmet House",
              path: "B9_5_10",
              child: [],
            },
            
            {
              name: "",
              path: "/",
              child: [],
            },
          ],
        },
        {
          name: "Level 13",
          path: "/",
          child: [
            {
              name: "Artisan Lounge",
              path: "B9_13_3",
              child: [],
            },
            {
              name: "Outdoor Artisan Lounge",
              path: "B9_13_7",
              child: [],
            },
            {
              name: "Outdoor Cinema",
              path: "B9_13_8",
              child: [],
            },
            {
              name: "Kids' Playground",
              path: "B9_13_6",
              child: [],
            },
            {
              name: "Observation Deck",
              path: "B9_13_5",
              child: [],
            },
            {
              name: "Cigar Room",
              path: "B9_13_1",
              child: [],
            },
            
          ],
        },
      ],
    },
   
    {
      name: "Unit Plans",
      path: "/about",
      child: [
        {
          name: "Orchard Hill I",
          path: "/",
          child: [
            {
              name: "Level 4",
              path: "B10_L4",
            }, {
              name: "Level 5",
              path: "B10_L5",
            }, {
              name: "Level 6-12",
              path: "B10_L6",
            },{
              name: "Level 13",
              path: "B10_L13",
            } , {
              name: "Level 14-23",
              path: "B10_L6",
            }, {
              name: "Level 24",
              path: "B10_L24",
            }, {
              name: "",
              path: "/",
            }, {
              name: "",
              path: "/",
            }
           
          ]
        },
        {
          name: "Orchard Hill II",
          path: "/",
          child: [
            

            {
              name: "Level 4",
              path: "B9_L4",
            }, {
              name: "Level 5",
              path: "B9_L5",
            }, {
              name: "Level 6",
              path: "B9_L6",
            }, {
              name: "Level 7-12",
              path: "B9_L7",
            } , {
              name: "Level 13",
              path: "B9_L13",
            },{
              name: "Level 14-23",
              path: "B9_L7",
            },{
              name: "Level 24",
              path: "B9_L24",
            }, {
              name: "",
              path: "/",
            }
          ],
        },
      ],
    },
  ]